import React from "react";

import { useIntl } from "react-intl";

import Tag from "ds/Tag";

const InternalTag = () => {
  const intl = useIntl();
  return (
    <Tag variant="gray">{intl.formatMessage({ id: "internal_only_tag" })}</Tag>
  );
};

export default InternalTag;
